import { render } from "./MainPenTestForm.vue?vue&type=template&id=6c9f3d70&scoped=true"
import script from "./MainPenTestForm.vue?vue&type=script&lang=js"
export * from "./MainPenTestForm.vue?vue&type=script&lang=js"

import "./MainPenTestForm.vue?vue&type=style&index=0&id=6c9f3d70&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c9f3d70"]])

export default __exports__